export default "__VITE_ASSET__BJuedcaQ__"